import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowFitBottomRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.345 1.499a.5.5 0 0 0-.5-.5H.999v4.845h.5-.5a.5.5 0 0 0 1 0h-.5.5V2.705L9.293 10h-5.31a.5.5 0 0 0 0 1H9.5A1.5 1.5 0 0 0 11 9.5V3.982a.5.5 0 0 0-1 0v5.312L2.706 1.999h3.139a.5.5 0 0 0 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomRight12);
